import { useEffect, useState } from 'react';
import CalenderLinks from '../../../components/CalanderLinks/CalanderLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import './Durga.scss';

const Durga = () => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [durgaData, setDurgaData] = useState([]);

    // temporary values (for input fields)
  const [tempYear, setTempYear] = useState(currentYear);


    // ---- New state for modal ----
  const [selectedEvent, setSelectedEvent] = useState(null); // Stores the event clicked
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFestivalDetail, setSelectedFestivalDetail] = useState(null);


  const durgaPujaFestivalTooltips = {
  "Bilva Nimantran": "Bilva Nimantran marks the invitation of Goddess Durga into the home and heart by symbolically invoking her through a Bilva (Bel) tree branch.",

  "Kalparambha": "Kalparambha is the formal beginning of Durga Puja rituals, typically performed in the early morning of Shashthi.",
  "Akal Bodhon": "Akal Bodhon refers to the untimely invocation of Goddess Durga by Lord Rama before the traditional time, symbolizing urgency and devotion.",
  "Amantran and Adhivas": "Amantran and Adhivas are the rituals of inviting the Goddess and sanctifying the site of worship, performed on Shashthi evening.",

  "Durga Saptami": "Durga Saptami is the first day of Maha Puja, where the idol is formally infused with life (Pran Pratishtha) and the Navapatrika (Kolabou) is bathed.",
  "Kolabou Puja": "Kolabou Puja involves the ceremonial bathing and dressing of the banana plant, symbolizing Goddess Durga's consort, invoked as part of Saptami rituals.",

  "Durga Ashtami": "Durga Ashtami is one of the most auspicious days of Navratri when devotees offer special prayers to Goddess Durga’s fierce form, Mahagauri.",
  "Kumari Puja": "Kumari Puja is the ritual of worshipping a young girl as the living embodiment of the Goddess Durga, representing purity and divine energy.",
  "Sandhi Puja": "Sandhi Puja is performed at the juncture of Ashtami and Navami tithis — considered the most powerful moment of the Puja, symbolizing divine transition.",

  "Maha Navami": "Maha Navami is the final day of battle before victory, marked with grand pujas, processions, and community celebrations.",
  "Durga Balidan": "Durga Balidan (sacrifice ritual) is traditionally performed during Navami in some regions, symbolizing selfless offering to the Goddess.",
  "Navami Homa": "Navami Homa is a sacred fire ritual performed to seek divine blessings and purification on Maha Navami.",

  "Durga Visarjan": "Durga Visarjan marks the immersion of the Durga idol, signifying the conclusion of the festival and the Goddess's return to her celestial abode.",
  "Vijayadashami": "Vijayadashami, or Dussehra, celebrates the victory of good over evil — symbolized by the defeat of Mahishasura by Goddess Durga.",
  "Sindoor Utsav": "Sindoor Utsav is a ritual where married women apply vermillion (sindoor) to the Goddess and each other, wishing for long married life and prosperity."
};

const popups = {
  "Bilva Nimantran": "Bilva Nimantran marks the ceremonial invitation of Goddess Durga into the home and devotees' hearts. A branch of the sacred Bilva (Bel) tree is used to symbolize her presence, and prayers are offered to invite divine energy into the household. It is believed that performing this ritual brings prosperity, peace, and protection to family members while establishing a spiritual connection with the Goddess for the entire duration of the festival.",

  "Kalparambha": "Kalparambha signifies the formal beginning of Durga Puja rituals. Performed typically early in the morning on Shashthi, it involves setting up the altar, arranging offerings, and reciting specific prayers to commence the spiritual activities. This ritual symbolizes preparation, purity, and readiness to receive the Goddess, ensuring that the puja is conducted with devotion, order, and respect for ancient traditions.",

  "Akal Bodhon": "Akal Bodhon is the ‘untimely awakening’ of Goddess Durga, historically performed by Lord Rama when he invoked the Goddess before the scheduled time to seek her blessings against evil forces. This ritual emphasizes urgency in devotion and the power of the Goddess to respond to sincere prayers regardless of formal timings. Participants often chant mantras, offer flowers, and light lamps to honor this exceptional invocation.",

  "Amantran and Adhivas": "Amantran and Adhivas are evening rituals on Shashthi that formally invite Goddess Durga into the worship site and sanctify the area of puja. Special prayers, offerings, and decorations are prepared, often accompanied by lighting lamps and chanting sacred hymns. These ceremonies create a spiritual ambiance, welcoming the Goddess to bless devotees with protection, prosperity, and spiritual growth throughout the festival.",

  "Durga Saptami": "Durga Saptami marks the first major day of Maha Puja. The idol is ritually infused with life through Pran Pratishtha, symbolizing the Goddess’s divine presence. The Navapatrika, or ceremonial banana plant representing the Goddess's consort, is bathed and adorned. Devotees perform prayers, offer flowers, fruits, sweets, and recite hymns praising Durga's power and compassion, creating a sacred environment that fosters devotion and communal celebration.",

  "Kolabou Puja": "Kolabou Puja involves worshipping a banana plant as a symbolic consort of Goddess Durga. The plant is bathed, decorated, and adorned with clothes and ornaments. This ritual represents fertility, prosperity, and the nurturing aspects of divine energy. Devotees believe that honoring Kolabou alongside the Goddess ensures household harmony, blessings for family members, and a spiritually charged atmosphere during Durga Puja.",

  "Durga Ashtami": "Durga Ashtami is one of the most sacred days of Navratri, celebrated with immense devotion and grandeur. Devotees honor Goddess Durga in her fierce form, Mahagauri, performing extensive prayers, fasting, and offerings. Kumari Puja is also performed, worshipping young girls as embodiments of the Goddess to symbolize purity and divine energy. Sandhi Puja is observed at the exact juncture between Ashtami and Navami tithis, considered the most potent moment of the festival, invoking maximum divine power for protection and prosperity.",

  "Kumari Puja": "Kumari Puja is a significant ritual during Durga Ashtami where a prepubescent girl is worshipped as the living form of Goddess Durga. She is bathed, adorned with fine clothes, and offered sweets and gifts. This ceremony represents the worship of purity, innocence, and the manifestation of divine feminine energy. Families believe that honoring Kumari ensures the blessings of the Goddess on all members, fostering spiritual growth, health, and harmony within the household.",

  "Sandhi Puja": "Sandhi Puja is performed at the critical juncture when Ashtami transitions into Navami, considered the most sacred and powerful time of Durga Puja. Devotees offer 108 lamps, chant hymns, and perform elaborate rituals to honor the Goddess at her peak energy. It symbolizes the triumph of divine energy over evil and is believed to remove obstacles, negative influences, and misfortunes from devotees’ lives, ensuring spiritual and material well-being.",

  "Maha Navami": "Maha Navami is the penultimate day of Durga Puja and commemorates the final preparations before victory. Grand rituals, processions, and community celebrations are conducted with devotion and fervor. Fire rituals (Homa) are performed to seek purification and blessings, while devotees offer special prayers for prosperity, protection, and courage. The day symbolizes readiness, collective spiritual energy, and the approaching triumph of good over evil.",

  "Durga Balidan": "Durga Balidan involves symbolic offerings or sacrifices to the Goddess, representing selflessness, devotion, and surrender. Traditionally, these offerings may include fruits, flowers, or other sacred items, sometimes performed as a public ritual. The ceremony reflects the devotee’s dedication to spiritual growth, moral discipline, and acknowledgment of the Goddess’s supreme power over life and destiny.",

  "Navami Homa": "Navami Homa is a sacred fire ritual performed on Maha Navami to invoke divine blessings, purification, and protection. Offerings are made into the fire while chanting specific mantras, symbolizing devotion, surrender, and spiritual purification. This ritual is considered highly auspicious, ensuring that the household and community receive positive energy, abundance, and divine grace.",

  "Durga Visarjan": "Durga Visarjan marks the culmination of Durga Puja with the immersion of the idol in water bodies, symbolizing the Goddess’s return to her celestial abode. Devotees sing devotional songs, chant hymns, and participate in processions while bidding farewell to the divine presence. The ritual teaches detachment, the cyclical nature of life, and reverence for divine energy, while also strengthening communal bonds and devotion.",

  "Vijayadashami": "Vijayadashami, also known as Dussehra, celebrates the ultimate victory of good over evil, symbolized by Goddess Durga defeating the demon Mahishasura. Large processions, cultural performances, and community festivities are organized to mark the occasion. The day emphasizes moral values, courage, righteousness, and devotion, inspiring devotees to uphold dharma (virtue) in personal and social life.",

  "Sindoor Utsav": "Sindoor Utsav is celebrated with enthusiasm on Vijayadashami, where married women apply sindoor (vermilion) on each other and on the Goddess idol. The ritual signifies marital bliss, longevity of husbands, prosperity, and the celebration of feminine energy. Participants also pray for familial harmony, fertility, and continued blessings from Goddess Durga, making it a joyous, colorful, and spiritually meaningful event."
};



  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`https://core-c343.onrender.com/api/durgaPuja?year=${year}`);
        const data = await res.json();
        if (data?.months?.length) {
          setDurgaData(data.months);
        }
      } catch (error) {
        console.error('Error fetching Durga Puja data:', error);
      }
    };

    fetchData();
  }, [year]);


    const handleSubmit = () => {
  setYear(tempYear);
};


  // ---- New: open modal ----
const openDetailPage = (eventName, item) => {
  setSelectedFestivalDetail({
    name: eventName,
    date: item.date,
    weekday: item.weekday,
    tithi: item.tithi,
    bengaliDate: item.bengaliDate,
    description: popups[eventName]
  });
};


  // ---- New: close modal ----
  const handleCloseModal = () => {
    setSelectedEvent(null);
    setIsModalOpen(false);
  };

// ================== DETAIL PAGE ==================
if (selectedFestivalDetail) {
  return (
    <div className="Durga-container">
      <InnerNav />

      <div className="Durga-content">
        <button
          className="back-btn"
          onClick={() => setSelectedFestivalDetail(null)}
        >
          ← Back
        </button>

        <h1 className="s-heading">{selectedFestivalDetail.name}</h1>

        <p><strong>Date:</strong> {selectedFestivalDetail.date}</p>
        <p><strong>Weekday:</strong> {selectedFestivalDetail.weekday}</p>

        {selectedFestivalDetail.tithi && (
          <p><strong>Tithi:</strong> {selectedFestivalDetail.tithi}</p>
        )}

        {selectedFestivalDetail.bengaliDate && (
          <p><strong>Bengali Date:</strong> {selectedFestivalDetail.bengaliDate}</p>
        )}

        <p style={{ marginTop: '20px', lineHeight: '1.6' }}>
          {selectedFestivalDetail.description || 'Description not available.'}
        </p>
      </div>

      <Footer />
    </div>
  );
}

  return (
    <div className="Durga-container">
      <InnerNav />

      <div className="Durga-content">
       <div className="year-selector">
        <label htmlFor="year">Select Year: </label>
        <input
          id="year"
          type="number"
          min="1900"
          max="2100"
          value={tempYear}
          onChange={(e) => setTempYear(Number(e.target.value))}
        />
        <button className="submit" onClick={handleSubmit}>Submit</button>
      </div>

        <h1 className="s-heading">{year} Durga Puja</h1>

        {durgaData.map((item, index) => (
          <div className="Durga-card" key={index}>
            <div className="card-header">{item.dayLabel}</div>

            <div className="card-body">
              <div className="s-right-section">
                <div className="s-badge">{item.dayCount}</div>
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/4/49/Shades_of_Maa_Durga.jpg"
                  alt="Goddess Durga"
                />
              </div>

              <div className="s-details">
                <ul className="s-festivals">
                  {item.festivals?.map((fest, idx) => (
                    <li key={idx} className="tooltip-wrapper">
                         <span
                        className="event-text"
                        onClick={() => openDetailPage(fest, item)}
                        style={{ cursor: 'pointer', textDecoration: 'underline #da1c1cff', color: '#b31414ff' }}
                      >
                        Event: {fest}
                      </span>
                        {/* {durgaPujaFestivalTooltips[fest] && (
                          <span className="tooltip">{durgaPujaFestivalTooltips[fest]}</span>
                        )} */}
                      </li> 
                  ))}
                </ul>

                {item.tithi && (
                  <p className="s-tithi"><strong>Tithi:</strong> {item.tithi}</p>
                )}

                {item.bengaliDate && (
                  <p className="s-bengali-date"><strong>Bengali Date:</strong> {item.bengaliDate}</p>
                )}

                {item.panchangNote && (
                  <p className="s-note"><em>{item.panchangNote}</em></p>
                )}
              </div>

              <div className="date-box">
                <div className="date">{item.date}</div>
                <div className="weekday">{item.weekday}</div>
              </div>
            </div>
          </div>
        ))}

        <CalenderLinks />
      </div>

      <Footer />
      {/* ---- New: Modal ---- */}
      {isModalOpen && selectedEvent && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedEvent}</h2>
            <p>{popups[selectedEvent]}</p>
            <button className="close-btn" onClick={handleCloseModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Durga;
